<div class='head'>
    <div class='container'>
        <h1 class='contact'>
            FAQ
        </h1>
        <p>
            <span class='subtitle'>GET ANSWERS TO YOUR QUESTIONS</span>
        </p>
    </div>
</div>
<br /><br />
<div class='container'>
    <p class='title'>
        General Issues
    </p>

    <div class='row'>
        <div class='col-md-6 col-12' *ngFor='let i of counter(12)'>
            <mat-accordion>
                <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                          Self aware panel
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <p>I'm visible because I am open</p>
                </mat-expansion-panel>
            </mat-accordion>              
        </div>
    </div>
</div>